export const installments = {
    showBonusInterestRates: true,
};
